import { ModalAction } from "@/store/modal/state";
import { Modal, Button } from "ant-design-vue";
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";
import { DynamicKeysObject } from "@/utils/type";
import { MODULES, vuexName } from "@/store/utils";

export default defineComponent({
  components: { Modal, Button },
  setup() {
    const { getters, commit } = useStore();
    const dataFromView = ref();
    const isOpen = computed<boolean>(() => getters[vuexName(MODULES.MODAL.GETTERS.GET_IS_OPEN)]);
    const isSubmitting = computed<boolean>(() => getters[vuexName(MODULES.MODAL.GETTERS.GET_IS_SUBMITTING)]);
    const title = computed<string>(() => getters[vuexName(MODULES.MODAL.GETTERS.GET_TITLE)]);
    const actions = computed<ModalAction[]>(() => getters[vuexName(MODULES.MODAL.GETTERS.GET_ACTIONS)]);
    const view = computed<object>(() => getters[vuexName(MODULES.MODAL.GETTERS.GET_VIEW)]);
    const extraProps = computed<DynamicKeysObject>(() => getters[vuexName(MODULES.MODAL.GETTERS.GET_PROPS)]);
    const closeable = computed<boolean>(() => extraProps.value["closeable"]);
    const isFooterHidden = computed<boolean>(() => extraProps.value["isFooterHidden"]);

    const handleOk = () => {
      actions.value[0]?.callback(dataFromView.value);
    };
    const handleCancel = () => {
      actions.value[1]?.callback();
      commit(vuexName(MODULES.MODAL.COMMITS.CLOSE));
    };
    const submitText = computed(() => actions.value[0]?.label);
    const cancelText = computed(() => actions.value[1]?.label);
    const onDataFromViewUpdate = (payload: any) => {
      dataFromView.value = payload;
    };
    return {
      isOpen,
      actions,
      view,
      closeable,
      isFooterHidden,
      handleOk,
      handleCancel,
      title,
      submitText,
      cancelText,
      extraProps,
      onDataFromViewUpdate,
      dataFromView,
      isSubmitting,
    };
  },
});
